<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Documents " />
            <DocumentPoste />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import DocumentPoste from '../MediathequePoste/DocumentPoste'
import FooterComp from '../Layouts/FooterComp'

export default {
    name: 'DocumentPostePage',
    components: {
        NavBar,
        PageTitle,
        DocumentPoste,
        FooterComp,
    }
}
</script>